import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { UserContext } from '../../contexts/UserContext'
//import styles
import style from './a.module.scss'
//import components
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton'

const Profile = () => {

  const { user, setUser, saveUser, clearUser } = useContext(UserContext)
  const navigate = useNavigate();

  useEffect(() => { if (!user) { navigate('/signin') } }, [])

  const handleLogout = () => {
    navigate('/')
    clearUser()
    toast.info('Logged out 😔')
  }

  return (
    <div className={style.div}>
      {user && user.name}
      <div className='' onClick={handleLogout} >
        <PrimaryButton title="Logout" />
      </div>
    </div>
  )
}

export default Profile
